import React from "react";
import PropTypes from "prop-types";
import Article from "../../models/Article";
import tailwindColors from "../../../../../../tailwind.colors";

function DownloadPdf({ article }) {
  return (
    <div
      data-tooltip={article.pdf ? "Download PDF" : "PDF not available"}
      className={
        article.pdf
          ? "tw-opacity-90 hover:tw-opacity-100 tw-font-bold"
          : "tw-text-blueGray-400 tw-font-bold"
      }
    >
      <a
        href={article.pdf}
        className={article.pdf ? "" : "tw-pointer-events-none"}
        style={{
          color: article.pdf
            ? tailwindColors.blue["500"]
            : tailwindColors.blueGray["300"],
        }}
        tabIndex={0}
        target="_blank"
        rel="noreferrer"
      >
        PDF
      </a>
    </div>
  );
}

DownloadPdf.propTypes = {
  article: PropTypes.instanceOf(Article).isRequired,
};

DownloadPdf.defaultProps = {};

export default DownloadPdf;
